module.exports = __webpack_public_path__ + "img/meta.b7d21ce1.png";